import React from 'react';
import { useTranslation } from 'react-i18next';
import { listRules } from '../Landing/Statement';

export default function Rules() {
  const [, i18n] = useTranslation();

  return <div className='flex flex-col gap-4'>{listRules(i18n.language)}</div>;
}
